import { PrimaryButton } from "@fluentui/react";
import * as React from "react";
import Select from "react-select";
// import styles from "../Clm365ContractManagement.module.scss";
import {
  Dropdown,
  IDropdownOption,
  Label,
  MessageBar,
  MessageBarType,
  TextField,
} from "office-ui-fabric-react";
import { languageModal } from "../loc/Clm365ContractManagementWebPartStrings";
import { customStyles } from "../UtilityFunctions/ReactSelectStyles";

const termOptions = [
  { key: "Day", text: "Day(s)" ,value: "Day", label: "Day(s)" },
  { key: "Week", text: "Week(s)" ,value: "Week", label: "Week(s)" },
  { key: "Month", text: "Month(s)" ,value: "Month", label: "Month(s)" },
  { key: "Year", text: "Year(s)" ,value: "Year", label: "Year(s)" },
  { key: "Indefinite", text: "Indefinite", value: "Indefinite", label: "Indefinite"}
];

function AddTermDialog({ addTermCallback,defaultValues,onTermChangeCallback, isTermDialogvisible}) {
  const strings = languageModal.getLanguageContent();
  const [selectedTerm, setSelectedTerm] = React.useState<any>(null);
  const [inputValue, setInputValue] = React.useState<any>(null);
  const [showMessageBar, setShowMessageBar] = React.useState<boolean>(false);
  
  const onTermChange = (value: any) => {
    setSelectedTerm(value.key);
    onTermChangeCallback(value.key);
    if (value.key === "Indefinite") {
      setInputValue('');
  };
  };
  React.useEffect(() => {
         if(defaultValues?.count){
            setInputValue(defaultValues.count)
         }
         if(defaultValues?.term){
          setSelectedTerm(defaultValues?.term)
         }
  },[])

  React.useEffect(() => {
    if (isTermDialogvisible) {
      setInputValue(null);
      setSelectedTerm(null);
    }
  }, [isTermDialogvisible]);

  const onPasteChange = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const sanitized = pastedText.replace(/[^0-9]/g, "");
      handleInputChange(
        { target: { value: sanitized } } as React.ChangeEvent<HTMLInputElement>,
        sanitized
      );
   
};

  const handleInputChange = React.useCallback(
    (
      event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
      newValue?: string
    ) => {
        if(parseInt(newValue) > 0){
            setInputValue(newValue || '');
        }else{
            setInputValue('')
        }
    },
    []
  );

  return (
    <div style={{ display: "block", gap: "2px" }}>
      <div style={{ display: "flex", gap: "10px",alignItems:"center" }}>

        <TextField
          placeholder="0"
          styles={{
            root: {
              width: 100,
            },
          }}
          onPaste={onPasteChange}
          value={inputValue}
          onChange={handleInputChange}
          type="number"
          autoComplete="off"
          disabled={selectedTerm==="Indefinite"}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-", "."].includes(e.key)) {
              e.preventDefault();
            }
           }
          }
        />
        {/* <Dropdown
          placeholder={"Select Term"}
          options={termOptions}
          // styles={dropdownStyles}
          onChange={onTermChange}
          // defaultValue={selectedTerm}
          // defaultSelectedKey={defaultValues.term ? defaultValues.term : ""}
          styles={{
            root: {
              width: "100%",
            },
          }}
        /> */}

          <div style={{width: '100%'}}><Select
              placeholder={`${strings.Select} ${strings.Term}`}
              options={termOptions}
              menuPosition="fixed"
              menuPlacement="auto" 
              value={
                selectedTerm != undefined &&
                selectedTerm != null &&
                termOptions.filter(({ key }) => key === selectedTerm)
              }
              // isDisabled={!Component12}
              isSearchable={true}
              onChange={(select) => onTermChange(select)}
             menuPortalTarget={document.body}
              styles={{
                ...customStyles,
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 100000000,
                }),
              }}
            /></div>
      </div>
      {showMessageBar && (
        <div style={{marginTop: 5}}><MessageBar
          messageBarType={MessageBarType.error}
          isMultiline={false}
          onDismiss={() => setShowMessageBar(false)}
          dismissButtonAriaLabel={"Close"}
        >
          {"Please Enter Term!"}
        </MessageBar></div>
      )}
      <div style={{ display:'flex',
            justifyContent:'center'}}>
      <PrimaryButton
        text={strings.Add}
        className={"savebutton"}
        onClick={() => {
          if((inputValue && selectedTerm) || selectedTerm === "Indefinite"){
                addTermCallback(inputValue, selectedTerm)
            }else{
                setShowMessageBar(true);
            }
        }}
        styles={{
          root: {
            marginTop: 10,
            height:20,
           
          },
        }}
      ></PrimaryButton>
      </div>

    </div>
  );
}
export default AddTermDialog;
